export class RouteInfo {

    // Static Properties
    static pages: RouteInfo[] = [
        {
            'Url': '/classroom360/studentLists',
            'Title': 'Student Lists',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/student360/academicHistory',
            'Title': 'Academic History',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/teams',
            'Title': 'Activities and Teams',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/announcements',
            'Title': 'Announcements',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': (V10: boolean): boolean => {
                return !V10;
            },
            'DisableYearDropdown': false
        },
        {
            'Url': '/classroom360/announcements',
            'Title': 'Announcements',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': (V10: boolean, C360: boolean): boolean => {
                return !V10 || C360;
            },
            'DisableYearDropdown': (V10: boolean, C360: boolean) => {
                return V10 && C360;
            }
        },
        {
            'Url': '/student360/studentTestData',
            'Title': 'Assessments',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/attendance',
            'Title': 'Attendance',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/automaticCallingPreferences',
            'Title': 'Automatic Calling Preferences',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/awards',
            'Title': 'Awards',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/calendar',
            'Title': 'Calendar',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/changeEmail',
            'Title': 'Change Email',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/changePassword',
            'Title': 'Change Password',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/schedule',
            'Title': 'Student Schedule',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/feesAndBilling',
            'Title': 'Fees & Billing',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/reportCardGrades',
            'Title': 'Grades',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/graduationPlan',
            'Title': 'Graduation Plan Progress',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/assignments',
            'Title': 'Assignments',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/courseRequests',
            'Title': 'Course Requests',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/health',
            'Title': 'Health',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/lunchMealPlanner',
            'Title': 'Meal Service',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/mealService',
            'Title': 'Meal Service',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/notificationPreferences',
            'Title': 'Notification Preferences',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/setNotificationPreferences',
            'Title': 'Set Notification Preferences',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/onlineRegistration',
            'Title': 'Online Registration',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/onlineRegistration/householdParents',
            'Title': 'Online Registration',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/onlineRegistration/householdAddresses',
            'Title': 'Online Registration',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/onlineRegistration/student',
            'Title': 'Online Registration',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/onlineRegistration/nonresidentParents',
            'Title': 'Online Registration',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/onlineRegistration/emergencyContacts',
            'Title': 'Online Registration',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/onlineRegistration/customForm',
            'Title': 'Online Registration',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/parentPortalDataUpdate',
            'Title': 'Update Household Data',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/parentPortalDataUpdate/householdParents',
            'Title': 'Update Household Data',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/parentPortalDataUpdate/householdAddresses',
            'Title': 'Update Household Data',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/parentPortalDataUpdate/student',
            'Title': 'Update Household Data',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/parentPortalDataUpdate/nonresidentParents',
            'Title': 'Update Household Data',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/parentPortalDataUpdate/emergencyContacts',
            'Title': 'Update Household Data',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/parentPortalDataUpdate/healthMedical',
            'Title': 'Update Household Data',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/programsAndServices',
            'Title': 'Programs and Services',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/discipline',
            'Title': 'Discipline',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/sendEmail',
            'Title': 'Send Email',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/setNotificationPreferences',
            'Title': 'Set Notification Preferences',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/studentDetails',
            'Title': 'Student Details',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/studentDocuments',
            'Title': 'Documents',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/portfolios',
            'Title': 'Student Portfolio',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/student360/studentSummary',
            'Title': 'Student Summary',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/transportation',
            'Title': 'Transportation',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/classroomSummary',
            'Title': 'Classroom Summary',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/cards',
            'Title': 'Classroom Summary',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/classroomAttendance',
            'Title': 'Attendance',
            'ClassroomPage': true,
            'RequiredCourse': true,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'HidePrintButton': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/student360/onlinePayment',
            'Title': 'Online Payment',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/classroom360/communicationLog',
            'Title': 'Communication Log',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/teacherComments',
            'Title': 'Teacher Comment Library',
            'PrintStyle': './assets/styles/print-styles/teacher-comment.print.css',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/classroom360/disciplineReferral',
            'Title': 'Discipline Referral',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/behaviorReferral',
            'Title': 'Behavior Referral',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/reviewBehaviorReferrals',
            'Title': 'Review Behavior Referrals',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/manageBehaviorReferrals',
            'Title': 'Manage Behavior Referrals',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/gradebook/V10',
            'Title': 'Gradebook',
            'ClassroomPage': true,
            'RequiredCourse': true,
            'isV10': true,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/classroom360/gradebook/V9',
            'Title': 'Gradebook',
            'ClassroomPage': true,
            'RequiredCourse': true,
            'isV10': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/gbaddAssignment',
            'Title': 'Add Assignment',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/dataQuery',
            'Title': 'Data Query',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/classAnnouncements',
            'Title': 'Class Announcements',
            'ClassroomPage': true,
            'RequiredCourse': true,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/classroom360/links',
            'Title': 'Links',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/studentNotes',
            'Title': 'Student Notes',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/reportsQueue',
            'Title': 'Report Queue',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/reports',
            'Title': 'Reports',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/teacherProfile',
            'Title': 'Teacher Profile',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/classInformation',
            'Title': 'Class Information',
            'ClassroomPage': true,
            'RequiredCourse': true,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/staffMealService',
            'Title': 'Meal Service',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/teamAttendance',
            'Title': 'Team Attendance',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/classroom360/seatingChart',
            'Title': 'Seating Charts',
            'ClassroomPage': true,
            'RequiredCourse': true,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/classroom360/studentNextCourseRequests',
            'Title': 'Student Next Course Requests',
            'ClassroomPage': true,
            'RequiredCourse': true,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/massEmailLog',
            'Title': 'Email Log',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/studentFields',
            'Title': 'Student Fields',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/scheduledExports',
            'Title': 'Scheduled Exports',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/behavior/behaviorEvents',
            'Title': 'Behavior Events',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/behavior/interventions',
            'Title': 'Interventions',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/behavior/behaviorEvents/addEvent',
            'Title': 'Behavior Event',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/districtCourseRequestSetup',
            'Title': 'District Course Request Setup',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/schoolCourseRequestSetup',
            'Title': 'School Course Request Setup',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/bellSchedule/districtBellSchedule',
            'Title': 'District Bell Schedules',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/bellSchedule/schoolBellSchedule',
            'Title': 'School Bell Schedules',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/bellSchedule/schoolDateAssignments',
            'Title': 'Days Assigned to Dates',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/schoolCourseRequestSetup',
            'Title': 'School Course Request Setup',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/districtCourseRequestSetup',
            'Title': 'District Course Request Setup',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/bellSchedule/editDistrictBellSchedule',
            'Title': 'Edit District Bell Schedules',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/bellSchedule/editSchoolBellSchedule',
            'Title': 'Edit School Bell Schedules',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/schoolSchedulingFolders',
            'Title': 'School Scheduling Folders',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/schedulingGroups/schedulingGroupsList',
            'Title': 'School Scheduling Groups',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/classesByCourse',
            'Title': 'Classes By Course',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/potentialConflicts',
            'Title': 'Potential Conflicts',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/gradeLevelSchedulingSummary',
            'Title': 'Grade Level Scheduling Summary',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/masterschedule',
            'Title': 'Master Schedule',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/sections',
            'Title': 'Sections',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/scheduleStudentList',
            'Title': 'Schedule Student List',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/teacherSchedulingSettings',
            'Title': 'Teacher Scheduling Settings',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/roomSchedulingSettings',
            'Title': 'Room Scheduling Settings',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/iepAlerts',
            'Title': 'Individulized Education Program',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false
        },
        {
            'Url': '/counselor360/academicHistory',
            'Title': 'Academic History',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/student360/courseRequest',
            'Title': 'Course Request',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/studentCourseRequest',
            'Title': 'Course Requests',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/student360/studentDigitalContent',
            'Title': 'Student Digital Content',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': false
        },
        {
            'Url': '/counselor360/scheduling/studentSchedulingSettings',
            'Title': 'Student Scheduling Settings',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/admin360/eForms/processing',
            'Title': 'Manage e-Forms',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/admin360/eForms/surveyprocessing',
            'Title': 'Mange Surveys',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/periodStatistics',
            'Title': 'Period Statistics',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/studentSchedulingLinks',
            'Title': 'Student Scheduling Links',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/studentTeams',
            'Title': 'Student Teams',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/awardsGenerator',
            'Title': 'Academic Awards and Honor Roll',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/admin360/districtannouncements',
            'Title': 'District Announcements',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/admin360/schoolannouncements',
            'Title': 'School Announcements',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/counselor360/scheduling/classRoster',
            'Title': 'Class Roster',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true
        },
        {
            'Url': '/admin360/notifications/notificationEvents',
            'Title': 'Notification Events',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false,
        },
        {
            'Url': '/admin360/notifications/notificationGroups',
            'Title': 'Notification Groups',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false,
        },
        {
            'Url': '/admin360/notifications/myNotificationSettings',
            'Title': 'My Notification Settings',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false,
        },
        {
            'Url': '/admin360/notifications/myNotifications',
            'Title': 'My Notifications',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': false,
        },
        {
            'Url': '/admin360/contactTracing',
            'Title': 'Contact Tracing',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/management360/school/schoolSettingsParentNotification',
            'Title': 'Contact Tracing',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true,
            'DisableYearDropdown': false
        },
        {
            'Url': '/management360/school/schoolSettingsAttendance',
            'Title': 'Contact Tracing',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true,
            'DisableYearDropdown': false
        },
        {
            'Url': '/management360/school/schoolSettingsGeneral',
            'Title': 'Contact Tracing',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true,
            'DisableYearDropdown': false
        },
        {
            'Url': '/management360/staff/permissionsGroups',
            'Title': 'Permissions Groups',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/management360/staff/staffDocuments',
            'Title': 'Staff Document',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedManagement/fieldsWithinForms',
            'Title': 'Fields Within Forms',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedManagement/formsSetup',
            'Title': 'Forms Setup',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedManagement/collectionsOfForms',
            'Title': 'Collection Of Forms',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedHome',
            'Title': 'Special Services Home',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/management360/district/parentStudentPortalSettings',
            'Title': 'Parent/Student Portal Settings',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/admin360/registrationEnrollment/householdInformation',
            'Title': 'Household Information',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/admin360/registrationEnrollment/detailedRegistration',
            'Title': 'Household Registration',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true,
            'DisableYearDropdown': false
        },
        {
            'Url': '/student360/scheduleHistory',
            'Title': 'Schedule History',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/student360/scheduleHistory/multipleStudent',
            'Title': 'Schedule History',
            'ClassroomPage': false,
            'RequiredCourse': false,
            'ShowSchoolDropdown': true,
            'ShowYearDropdown': true,
            'DisableYearDropdown': false
        },
        {
            'Url': '/sped360/studentDocumentHome',
            'Title': 'Special Services Student Documents Homepage',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/admin360/integrationFramework',
            'Title': 'Scheduled Imports/Exports',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'isV10': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/admin360/integrationFramework/quickImport',
            'Title': 'Quick Import',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'isV10': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/admin360/integrationFramework/integrationQueue',
            'Title': 'Integration Queue',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'isV10': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedFormsWithinDocuments',
            'Title': 'Forms Within Document',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedManagement/accommodationsBank',
            'Title': 'Accommodation Bank',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedManagement/complianceRuleTable',
            'Title': 'Compliance Rule Table',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedManagement/districtCodeTables',
            'Title': 'District Code Tables',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedManagement/goalBank',
            'Title': 'Goal Bank',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/sped360/spedManagement/objectivesBank',
            'Title': 'Objectives Bank',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        },
        {
            'Url': '/gradingCycles',
            'Title': 'Grading Cycles',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true
        },
        {
            'Url': '/specialServiceEvaluations/viewEditEvaluationReport',
            'Title': 'Evaluation Report Writer',
            'ClassroomPage': true,
            'RequiredCourse': false,
            'ShowSchoolDropdown': false,
            'ShowYearDropdown': true,
            'DisableYearDropdown': true
        }
    ];

    // Properties
    Url: string;
    Title: string;
    PrintStyle?: string;
    ClassroomPage: boolean;
    RequiredCourse: boolean;
    isV10?: boolean;
    ShowSchoolDropdown: boolean;
    ShowYearDropdown: boolean | Function;
    HidePrintButton?: boolean;
    DisableYearDropdown?: boolean | Function;

    // Static Methods
    static getPageTitle(url: string) {
        // POST: returns to you a page title
        if (url.includes('?')) {
            url = url.substring(0, url.indexOf('?'));
        }
        const pageInfo = RouteInfo.pages.filter(function (page) {
            return page.Url == url;
        })[0];
        if (pageInfo) {
            return pageInfo.Title;
        } else {
            return '';
        }
    }
    // Static Methods
    static getPagePrintStyle(url: string) {
        // POST: returns to you a page title
        const pageInfo = RouteInfo.pages.filter(function (page) {
            return page.Url == url;
        })[0];
        if (pageInfo) {
            return pageInfo.PrintStyle;
        } else {
            return '';
        }
    }

    static getPageInfo(url: string) {
        const pageInfo = RouteInfo.pages.filter(function (page) {
            return page.Url == url;
        })[0];

        return pageInfo;
    }
}
